module.exports = __webpack_public_path__ + "static/media/trident_02.ab1f6459.jpg";